import React from 'react';

import styles from './SourceAccountEvent.module.css';

interface ISourceAccountEvent {
  acctNumber: number;
  acctType: string;
}

const SourceAccountClick = ({ acctNumber, acctType }: ISourceAccountEvent) => (
  <div className={styles.container}>
    <div className={styles.accountNumber}>{acctNumber}</div>
    <div className={styles.accountType}>{acctType}</div>
  </div>
);

export default SourceAccountClick;
